export const iconFontAwesomePoliticalPiggyBank = (
	<i className="fa-solid fa-piggy-bank"></i>
);
